import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { SelectCountryModule } from '@shared/select-country/select-country.module';
// import { FormRequestMoneyModule } from '@shared/mat-forms/request-money/request-money.module';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { RequestMoneyComponent } from './request-money.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SplitPaymentModule } from './split-payments/split-payment.module';
import { DevCycleService } from '@services/dev-cycle.service';
import { SplitPaymentFormModule } from './split-payment-form/split-payment-form.module';
import { SplitPaymentSummaryModule } from './split-payment-summary/split-payment-summary.module';

@NgModule({
  declarations: [RequestMoneyComponent],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    ClipboardModule,
    SelectCountryModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    SplitPaymentModule,
    SplitPaymentFormModule,
    SplitPaymentSummaryModule,
    // FormRequestMoneyModule
  ],
  providers: [DevCycleService],
  exports: [RequestMoneyComponent],
})
export class RequestMoneyModule {}
